import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const HeaderContainer = styled.header`
  background-color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
`;

const Logo = styled.div`
  img {
    height: 60px;
  }
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  font-weight: 600;
  font-size: 1.1rem;
  color: #2e7d32;
  transition: all 0.3s ease;
  
  &:hover {
    color: #1b5e20;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  font-size: 1.5rem;
  color: #2e7d32;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const ContactInfo = styled.div`
  background-color: #2e7d32;
  color: white;
  padding: 8px 0;
  font-size: 0.9rem;
`;

const ContactContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
  }
`;

const Header: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <HeaderContainer>
      <ContactInfo>
        <div className="container">
          <ContactContainer>
            <div>{t('address')}</div>
            <div>{t('phone')}</div>
          </ContactContainer>
        </div>
      </ContactInfo>
      <div className="container">
        <NavContainer>
          <Logo>
            <Link to="/">
              <img src="/src/assets/logo.png" alt="New Clean Logo" />
            </Link>
          </Logo>
          <NavLinks>
            <NavLink to="/">{t('home')}</NavLink>
            <NavLink to="/services">{t('services')}</NavLink>
            <NavLink to="/gallery">{t('gallery')}</NavLink>
            <NavLink to="/about">{t('about')}</NavLink>
            <NavLink to="/contact">{t('contact')}</NavLink>
          </NavLinks>
          <MobileMenuButton>☰</MobileMenuButton>
        </NavContainer>
      </div>
    </HeaderContainer>
  );
};

export default Header;
